import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=298ec676&scoped=true"
import script from "./counter.vue?vue&type=script&lang=js"
export * from "./counter.vue?vue&type=script&lang=js"
import style0 from "./counter.vue?vue&type=style&index=0&id=298ec676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ec676",
  null
  
)

export default component.exports